function parseInnerHTML(html, selector) {
  return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
}
  
function refreshCart(updatedSections) {
  
  let cartSelector = document.getElementById('main-cart-items').dataset.id;
  document.getElementById("shopify-section-" + cartSelector).innerHTML = parseInnerHTML(updatedSections[cartSelector], "#shopify-section-" + cartSelector);

  document.getElementById('cart-icon-bubble').innerHTML = parseInnerHTML(updatedSections["cart-icon-bubble"], "#shopify-section-cart-icon-bubble");
  document.getElementById('cart-live-region-text').innerHTML = parseInnerHTML(updatedSections["cart-live-region-text"], "#shopify-section-cart-live-region-text");

  let footerSelector = document.getElementById('main-cart-footer').dataset.id;
  document.getElementById("shopify-section-" + footerSelector).innerHTML = parseInnerHTML(updatedSections[footerSelector], "#shopify-section-" + footerSelector);
}

function cartEventHandlers() {
  let attributeTextboxes = document.querySelectorAll('.noshi-input');
  attributeTextboxes.forEach(textbox => {
    textbox.addEventListener('blur', postCartAttribute);
  });
  
  let assemblageDropdowns = document.querySelectorAll('.assemblage-quantity-dropdown');
  assemblageDropdowns.forEach(aDropdown => {
    aDropdown.addEventListener('change', assemblageChangeQuantity);
  });
}

function clearCartItems(updates) {

  let sectionSelectors = document.getElementById('main-cart-items').dataset.id + ",cart-icon-bubble,cart-live-region-text," + document.getElementById('main-cart-footer').dataset.id;
  
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      updates: updates,
      sections: sectionSelectors
    })
  })
  .then((response) => response.json())
  .then((data) => {
    refreshCart(data.sections);
    return data;
  })
}

function clearCheckboxItemsAndAssemblage(assemblageHandle, assemblageId ) {
  let currentID = assemblageId;
  let updates = {};
  updates[currentID] = 0;
  clearCartItems(updates);
}

function updateCartAttributes(attributes) {
  fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: attributes
      })
    })
    .then(response => response.json())
    .then(cart => {
      console.log('Cart updated:', cart);
    })
    .catch(error => {
      console.error('Error updating cart:', error);
  });
}

function postCartAttribute(event){
  const attributeValue = this.value;
  
  if ((attributeValue.trim() !== '') && (attributeValue !== this.dataset.initial)) {
    let attributes = {}
    attributes[String(this.name)] = attributeValue;
    updateCartAttributes(attributes);
  }
  
}

function assemblageChangeQuantity(event) {
  console.log("Change!");
  const newQuantity = event.target.value;
  
  // Get the line item ID from the data attribute
  const variantId = event.target.getAttribute('data-assemblage-id');
  const assemblageHandle = event.target.getAttribute('data-assemblage-handle');
  console.log(newQuantity);
  console.log(assemblageHandle);

  if (newQuantity == 0) {
    console.log("Back to 0!");
    clearCheckboxItemsAndAssemblage(assemblageHandle, variantId);
  } else {
    console.log("Update!");
    let sectionSelectors = document.getElementById('main-cart-items').dataset.id + ",cart-icon-bubble,cart-live-region-text," + document.getElementById('main-cart-footer').dataset.id;
    // Send a POST request to update the quantity for this line item
    fetch('/cart/change.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({
            id: variantId,    // Line item ID
            quantity: newQuantity,  // New quantity
            sections: sectionSelectors
        })
    })
    .then(response => response.json())
    .then(data => {
        refreshCart(data.sections);
        return data;
    })
    .catch(error => {
        console.error("Error updating cart:", error);
    });
  }
}

function clearCart() {
  fetch('/cart/clear.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  .then(res => res.json())
  .then(data => {
    console.log('Cart cleared:', data);
  })
  .catch(err => console.error('Error clearing cart:', err));
}